import React from "react";
import TextField from "@mui/material/TextField";
import { useField } from "formik";
import { color } from "@mui/system";
import { styled } from "@mui/material/styles";
import { InputAdornment } from "@mui/material";

const StyledTextField = styled(TextField)({
  "& label": {
    color: "gray",
  },
  "&:hover label": {
    fontWeight: 700,
  },
  "& label.Mui-focused": {
    color: "#ffb510",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "white",
  },
  "& .MuiOutlinedInput-root": {
    color: "white",
    "& fieldset": {
      borderColor: "#ffb510",
    },
    "&:hover fieldset": {
      borderColor: "white",
      borderWidth: 2,
    },
    "&.Mui-focused fieldset": {
      borderColor: "#ffb510",
    },
  },
});

const TextfieldWrapper = ({ name, icon, ...otherProps }) => {
  const [field, mata] = useField(name);

  const configTextfield = {
    ...field,
    ...otherProps,
    fullWidth: true,
    variant: "outlined",
    margin: "normal",
    size: "small",
    InputProps: icon
      ? {
          startAdornment: (
            <InputAdornment position="start">{icon}</InputAdornment>
          ),
        }
      : undefined,
  };

  if (mata && mata.touched && mata.error) {
    configTextfield.error = true;
    configTextfield.helperText = mata.error;
  }

  return (
    <StyledTextField
      color="primary"
      autoComplete="off"
      sx={{
        "& .MuiInputBase-root": {
          height: 45,
        },
      }}
      {...configTextfield}
    />
  );
};

export default TextfieldWrapper;
